
function get (value, path, defaultValue) {
  const array = typeof path === 'string' ? String(path).split('.') : path

  return array.reduce((acc, v) => {
    try {
      acc = acc[v] || defaultValue
    } catch (e) {
      return defaultValue
    }
    return acc
  }, value)
}

export default get
